<ng-container [ngSwitch]="statusCode">
  <ng-container *ngSwitchCase="StatusCodes.SERVICE_UNAVAILABLE">
    {{ MaintenanceErrorMessage }}
  </ng-container>
  <ng-container *ngSwitchDefault>
    {{ GenericErrorMessage }}
  </ng-container>
</ng-container>
